<template>
  <div class="form-group">
    <label class="mt-checkbox" :for="id">{{ label }}
      <input type="checkbox" :id="id"
             :checked="value"
             :disabled="disabled"
             @click.stop="$emit('input', $event.target.checked)"/>
      <span></span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    }
  },
  emits: ['input']
}
</script>


<style scoped lang="scss">
.form-group {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// EditorCheckbox.vue?6e4b4c4b